import classNames from 'classnames';
import PropTypes from 'prop-types';

import MultiSelect from '@components/inputs/MultiSelect';
import {
  AMAZON_SALES_CHANNEL_ID,
  SALES_CHANNELS,
  SALES_CHANNELS_BY_ID_MAP,
  SALES_CHANNELS_STATUSES,
  SHOPIFY_SALES_CHANNEL_ID
} from '@sm/SalesChannels';

const SalesChannelMultiSelect = ({
  selectedSalesChannels,
  setSelectedChannels,
  salesChannelFilter,
  className,
  singleSelectMode,
  hideIfSingleChannelAvailable
}) => {
  const getSelectedOptionsView = state => {
    return (
      <div className="flex items-center h-10 gap-2">
        {state.map(channelId => {
          return (
            <div
              key={channelId}
              className="rounded bg-gray-lightest flex items-center justify-center h-8 w-8"
            >
              <img
                src={SALES_CHANNELS_BY_ID_MAP[channelId].short_icon}
                alt="channel"
                className={classNames('h-4 w-auto', {
                  'mt-px': channelId === AMAZON_SALES_CHANNEL_ID,
                  'mb-px': channelId === SHOPIFY_SALES_CHANNEL_ID
                })}
              />
            </div>
          );
        })}
      </div>
    );
  };

  const getOptionView = optionData => {
    const { channelData } = optionData;
    const salesChannelStatus = channelData.status;
    const getBadge = () => {
      if (salesChannelStatus === SALES_CHANNELS_STATUSES.NEW) {
        return (
          <div className="bg-red text-white text-xxs p-1 px-2 font-medium rounded-lg">NEW</div>
        );
      }
      if (salesChannelStatus === SALES_CHANNELS_STATUSES.COMING_SOON) {
        return (
          <div className="bg-white-dark text-gray-dark text-xxs p-1 px-2 font-medium rounded-lg">
            COMING SOON
          </div>
        );
      }
      return null;
    };
    return (
      <div className="h-10 flex gap-2 items-center justify-start flex-grow">
        <div className="flex items-center">
          <img
            src={
              channelData.combine_short_icon_and_name
                ? channelData.short_icon
                : channelData.full_icon
            }
            alt={channelData.name}
            style={{ height: '16px' }}
          />
          {!!channelData.combine_short_icon_and_name && (
            <div className="ml-1 font-medium text-sm">{channelData.name}</div>
          )}
        </div>
        {getBadge()}
      </div>
    );
  };

  const getOptions = () => {
    return SALES_CHANNELS.filter(salesChannelFilter)
      .filter(item => item.status)
      .map(channelData => {
        return {
          value: channelData.id,
          channelData,
          disabled: channelData.status === SALES_CHANNELS_STATUSES.COMING_SOON
        };
      });
  };

  const options = getOptions();
  if (hideIfSingleChannelAvailable && options.length === 1) return null;

  return (
    <MultiSelect
      className={classNames('h-10 text-gray-darkest', className)}
      state={selectedSalesChannels}
      setState={setSelectedChannels}
      options={options}
      getOptionView={getOptionView}
      getSelectedOptionsView={getSelectedOptionsView}
      popperOffset="0, 8px"
      singleSelectMode={singleSelectMode}
    />
  );
};

SalesChannelMultiSelect.propTypes = {
  selectedSalesChannels: PropTypes.instanceOf(Array).isRequired,
  setSelectedChannels: PropTypes.func.isRequired,
  salesChannelFilter: PropTypes.func,
  className: PropTypes.string,
  singleSelectMode: PropTypes.bool,
  hideIfSingleChannelAvailable: PropTypes.bool
};

SalesChannelMultiSelect.defaultProps = {
  salesChannelFilter: () => true,
  className: '',
  singleSelectMode: false,
  hideIfSingleChannelAvailable: true
};

export default SalesChannelMultiSelect;
